<template>
  <div class="pay-order-item tb" v-if="funcView.pay_order_list">
    <custom-tab :value="type" :list="tabList" @input="onTabChange" class="tab"></custom-tab>
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button v-if="`${type}` !== '2' && funcView.pay_order_pay_register" type="primary"
            :disabled="!tableSelect.length || !checkAuth(tableSelect, 'PAY_REGISTER')" @click="payReg(tableSelect)">
            {{ funcView.pay_order_pay_register }}
          </el-button>
          <el-button v-if="`${type}` !== '2' && funcView.pay_order_apply_delay" type="primary"
            :disabled="!tableSelect.length || !checkAuth(tableSelect, 'DELAY_PAYMENT')"
            @click="onDelayDialog(tableSelect)">
            {{ funcView.pay_order_apply_delay }}
          </el-button>
          <el-button type="primary" @click="batchRegister" v-if="funcView.pay_order_batch_register">{{
            funcView.pay_order_batch_register }}</el-button>
          <el-button v-if="funcView.pay_order_apply_invoice" type="primary"
            :disabled="!tableSelect.length || !checkAuth(tableSelect, 'INVOICE')"
            @click="invoiceApply(tableSelect, true)">
            {{ funcView.pay_order_apply_invoice }}
          </el-button>
          <el-button v-if="`${type}` !== '2' && funcView.pay_order_apply_free"
            :disabled="!tableSelect.length || !checkAuth(tableSelect, 'APPLY_FREE_PAYMENT')" type="primary"
            @click="applyFree(tableSelect, funcView.pay_order_apply_free, true)">
            {{ funcView.pay_order_apply_free }}
          </el-button>
        </el-form-item>
        <!-- 导出excel -->
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.pay_order_export_excel">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable"><i
              class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :class="!funcView.pay_order_export_excel ? 'mr-0' : ''">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.keyword" :placeholder="$t('fms_pay_order_item.htbhsghthjsh')"
            @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-form-item style="float: right" v-if="pageTypeData.length">
          <el-radio-group v-model="selfPageType" @change="onPageTypeChange">
            <el-radio-button :label="item.value" v-for="item in pageTypeData" :key="item.value">{{ item.label
              }}</el-radio-button>

          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('fms_pay_order_item.qrskrq')">
          <custom-date-picker style="width: 100%" v-model="formSearch.payableTradeConfirmTime" type="daterange"
            align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.ying_fu_gong_si')">
          <el-input v-model="formSearch.payableCompany" :placeholder="$t('fms_pay_order_item.ying_fu_gong_si')"
            clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.xiang_mu')">
          <el-input v-model="formSearch.locationName" :placeholder="$t('fms_pay_order_item.xiang_mu')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.shou_kuan_gong_si')">
          <el-input v-model="formSearch.receivableOrgName" :placeholder="$t('fms_pay_order_item.shou_kuan_gong_si')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.fu_kuan_dao_qi_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.billPaymentTime" type="daterange" align="right"
            value-format="YYYY-MM-DD HH:mm:ss" :init-value="formSearch.initBillPaymentTime"
            :key="billPaymentTimeKey"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.qrfkrq')" v-if="`${type}` !== '1'">
          <custom-date-picker style="width: 100%" v-model="formSearch.finalPaymentTime" type="daterange" align="right"
            value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <div class="half-content">
          <el-form-item :label="$t('fms_pay_order_item.she_bei_hao')" class="half-width">
            <el-input v-model="formSearch.deviceNo" :placeholder="$t('fms_pay_order_item.she_bei_hao')" type="number"
              :maxlength="1" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('fms_pay_order_item.qi_hao')" class="half-width">
            <el-input v-model="formSearch.termNum" :placeholder="$t('fms_pay_order_item.zhi_chi_qu_jian_ru25')" clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item :label="$t('fms_pay_order_item.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }" width="100%"
            :placeholder="$t('fms_pay_order_item.chan_pin_xing_hao')"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.fa_piao_hao_ma')">
          <el-input v-model="formSearch.invoiceNum" :placeholder="$t('fms_pay_order_item.fa_piao_hao_ma')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.kai_piao_zhuang_tai')">
          <custom-select v-model="formSearch.invoiceState" code="bill_invoice_show_status"
            :placeholder="$t('fms_pay_order_item.kai_piao_zhuang_tai')"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.kai_piao_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.invoiceTime" type="daterange" align="right"
            value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_order_item.zzyfrq')">
          <custom-date-picker style="width: 100%" v-model="formSearch.finalTime" type="daterange" align="right"
            value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table ref="customTb1" type="checkbox" height="100%" v-model="tableSelect" :data="tableList"
        :column="tableColumn" @sort="sortChange" @filter="filterChange" :clickSelection="true"
        :slots="['contractNo', 'isDelay', 'termNum', 'sharingClasses', 'invoiceAmount', 'lockInvoiceAmount', 'action']">
        <template v-slot:contractNo="scope">
          <div class="cell-link" @click.stop="toContractDetail(scope.row)">
            {{ scope.row.contractNo }}
          </div>
        </template>
        <template v-slot:isDelay="scope">
          {{ getUrgentView(scope.row) }}
        </template>
        <!--  已开票金额 -->
        <template v-slot:invoiceAmount="scope">
          <span v-if="funcView.pay_order_check_invoice && checkAuth(scope.row, 'CHECK_INOVIE')" class="underline"
            @click.stop="checkInvoiceDetail(scope.row)">{{ scope.row.invoiceAmount }}</span>
          <span v-else>{{ scope.row.invoiceAmount }}</span>
        </template>
        <template v-slot:termNum="scope">
          <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <template v-slot:sharingClasses="scope">
          <div>{{ scope.row.sharingClasses ? Array.from(new Set(scope.row.sharingClasses.split(','))).join(",") : '-' }}
          </div>
        </template>
        <template v-slot:action="scope">
          <span></span>
          <el-button v-if="`${type}` !== '2' && checkAuth(scope.row, 'PAY_REGISTER') && funcView.pay_order_pay_register"
            type="text" size="mini" @click.stop="payReg(scope.row)">
            {{ funcView.pay_order_pay_register }}
          </el-button>
          <el-button
            v-if="`${type}` !== '2' && checkAuth(scope.row, 'CANCEL_PAYMENT') && funcView.pay_order_cancel_payment"
            type="text" size="mini" @click.stop="cancelPayment(scope.row)">
            {{ funcView.pay_order_cancel_payment }}
          </el-button>
          <!-- 付款详情 -->
          <el-button
            v-if="`${type}` !== '1' && checkAuth(scope.row, 'CHECK_PAYMENT_INFO') && funcView.pay_order_check_payment"
            type="text" size="mini" @click.stop="checkPaymentInfo(scope.row, funcView.pay_order_check_payment)">
            {{ funcView.pay_order_check_payment }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <accounts-footer-sum :data="tableSelect" :totalPaymentAmount="totalData.totalPaymentAmount"></accounts-footer-sum>
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize"
        @change="onPageChange"></custom-page>
    </div>
    <!-- 付款登记 -->
    <accounts-registration-dialog :model="paymentRegistrationModel" v-if="paymentRegistrationVisible"
      @close="paymentRegistrationVisible = false" @success="getTableList" :paymentOrReceivable="true" :addBill="addBill"
      :delBill="delBill" :addTradeMsg="addTradeMsg" :editTradeMsg="editTradeMsg" :delTradeMsg="delTradeMsg"
      :cancelRegister="cancelRegister"
      :accountManage="!!funcView.pay_order_account_manage"></accounts-registration-dialog>
    <!-- 延期付款 -->
    <approval-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"
      @success="getTableList"></approval-dialog>
    <!-- 撤销付款 -->
    <cancel-payment-dialog v-if="cancelPaymentVisible" @close="cancelPaymentVisible = false" :model="cancelPaymentModel"
      @success="onPageChange({ page: 1 })"></cancel-payment-dialog>
    <!-- 查看付款详情 -->
    <accounts-payable-detail-dialog v-if="paymentInfoVisible" @close="paymentInfoVisible = false"
      :model="paymentInfoModel"></accounts-payable-detail-dialog>
    <!-- 申请开票 -->
    <invoice-apply-dialog :model="dialogModel6" v-if="dialogVisible6" @close="dialogVisible6 = false"
      @success="getTableList"></invoice-apply-dialog>
    <!-- 申请免收 -->
    <approval-dialog v-if="applyFreeVisible" @close="applyFreeVisible = false" :model="applyFreeModel"
      @success="getTableList"></approval-dialog>
    <!-- 查看发票信息 -->
    <invoice-bill-msg-dialog :model="invoiceBillMsgModel" v-if="invoiceBillMsgVisible"
      @close="invoiceBillMsgVisible = false" :invoiceDetail="invoiceDetail"
      :paymentOrReceivable="true"></invoice-bill-msg-dialog>
    <!-- 批量登记 -->
    <patch-register-dialog v-if="batchRegisterVisible" @close="batchRegisterVisible = false" :model="batchRegisterModel"
      @success="onBatchRegisterSuccess"></patch-register-dialog>
  </div>
</template>

<script>
/** 应付账单 */
import qs from 'qs';
import moment from 'moment';
import apis from '@/utils/apis';
import invoiceBillMsgDialog from '@/pages/fms/components/invoice_bill_msg_dialog';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import invoiceApplyDialog from '@/pages/fms/components/invoice_apply_dialog.vue';
import accountsFooterSum from '@/pages/fms/components/accounts_footer_sum.vue';
import accountsPayableDetailDialog from '@/pages/fms/components/accounts_payable_detail_dialog';
import mixins from '@/pages/fms/components/mixins';
import patchRegisterDialog from '@/pages/fms/components/patch_register_dialog.vue';
import tableFilterValueGetParamMixins from '@/mixins/table_filterValue_getParam_mixins.js';
import cancelPaymentDialog from '../../components/cancel_payment_dialog.vue';
import accountsRegistrationDialog from '../../components/accounts_registration_dialog';
import commonMixin from '../../mixins/commonMixin';


// 用于调试
const isMock = false;

export default {
  mixins: [commonMixin, mixins, tableFilterValueGetParamMixins],
  components: { accountsFooterSum, accountsRegistrationDialog, cancelPaymentDialog, accountsPayableDetailDialog, invoiceApplyDialog, approvalDialog, invoiceBillMsgDialog, patchRegisterDialog, },
  props: {
    type: [Number, String],
    pageType: [Number, String]
  },
  data() {
    const initBillPaymentTime = [`${this.$moment().format('YYYY-MM-01')} 00:00:00`, `${this.$moment().format('YYYY-MM-DD')} 23:59:59`];

    return {
      addBill: true,
      delBill: true,
      addTradeMsg: true,
      editTradeMsg: true,
      delTradeMsg: true,
      invoiceDetail: true,
      cancelRegister: true,
      selfPageType: '1',
      provide: true,
      dateType: 0,
      tableSelect: [],
      formSearch: {
        initBillPaymentTime: initBillPaymentTime,
        keyword: '',
        bodyNum: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        locationName: '',
        receivableOrgName: '',
        billPaymentTime: [
          this.$momentWorld(initBillPaymentTime[0]),
          this.$momentWorld(initBillPaymentTime[1])
        ],
        finalPaymentTime: '',
        tradeConfirmTime: '',
        payableTradeConfirmTime: '',
        deviceNo: '',
        productCode: '',
        invoiceState: '',
        payableCompany: '',
        invoiceNum: '',
        // 开票时间
        invoiceTime: '',
        // 最终应收日期
        finalTime: '',
        beginTime: '',
        endTime: '',
      },

      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      // 应收管理-确认收款
      dialogVisible3: false,
      dialogModel3: {},
      // 应收管理-登记收款
      dialogVisible4: false,
      dialogModel4: {},
      // 应收管理-收款记录
      dialogVisible5: false,
      dialogModel5: {},
      // 查看收款详情
      dialogVisible7: false,
      dialogModel7: {},

      // 批量登记
      batchRegisterVisible: false,
      batchRegisterModel: {},

      link: null,
      totalData: {
        totalPaymentAmount: 0
      },
      billPaymentTimeKey: 1,
      pageTypeData: []
    };
  },
  computed: {
    tableCode() {
      const map = {
        '1': 'fms_pay_order_wait', // term,deposit,breaks,late_fee,stock,sales_fee,sales_part,sales_data
        '2': 'fms_pay_order_received', // term,deposit,breaks,late_fee,stock,sales_fee,sales_part,sales_data
        '3': 'fms_pay_order_all' // term,deposit,breaks,late_fee,stock,sales_fee,sales_part,sales_data
      };
      return map[this.type];
    },
    tabList() {
      return [
        {
          name: this.$t('fms_pay_order_item.dai_fu_kuan'),
          value: '1'
        },
        {
          name: this.$t('fms_pay_order_item.yi_fu_kuan'),
          value: '2'
        },
        {
          name: this.$t('Common.com_all'),
          value: '3'
        }
      ];
    },
  },
  mounted: function () {
    this.selfPageType = this.pageType;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.initPageType();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getDicMap('invoice_state_t', () => {
      this.getTableList();
    });
    // this.loadFuncView(true);
  },
  methods: {
    batchRegister() {
      this.batchRegisterModel = {
        title: this.$t('fms_pay_order_item.pi_liang_deng_ji')
      };
      this.batchRegisterVisible = true;
    },
    onBatchRegisterSuccess(data) {
      this.batchRegisterVisible = false;
      this.payReg(data.row);

    },
    toContractDetail(row) {
      const { orderId, orderType } = row;
      if (!orderId) {
        this.$message.error(
          this.$t('fms_pay_order_item.sjycqsgjzd')
        );
        return;
      }
      const parentPath = this.$route.path;
      this.jump('/contractdetail', {
        contractId: orderId,
        contractClass: orderType,
        parentPath
      });
    },
    // 登记付款 -
    payReg(row) {
      const item = Array.isArray(row) ? row[0] : row;
      const reqDetailUrl = this.getPaymentInfoReqUrl(item);
      if (!reqDetailUrl) {
        this.$message.error(
          this.$t('fms_pay_order_item.sjycqsgjzd')
        );
        return;
      }
      this.cancelRegister = !!this.funcView.pay_order_cancel_register;
      this.addBill = !!this.funcView.pay_order_add_bill;
      this.delBill = !!this.funcView.pay_order_del_bill;
      this.addTradeMsg = !!this.funcView.pay_order_add_trade_msg;
      this.editTradeMsg = !!this.funcView.pay_order_edit_trade_msg;
      this.delTradeMsg = !!this.funcView.pay_order_del_trade_msg;
      this.paymentRegister(row, this.$t('fms_pay_order_item.deng_ji_fu_kuan'));
    },
    // -
    checkInvoiceDetail(row) {
      const billId = row.billId;
      if (!billId) {
        this.$message.error(
          this.$t('fms_pay_order_item.sjycqsgjzd')
        );
        return;
      }
      this.invoiceDetail = !!this.funcView.pay_order_invoice_detail;
      this.checkInvoiceBillMsg(row);
    },
    initPageType() {
      const userInfo = this.$store.state.userInfo;
      if (userInfo && userInfo.bizType) {
        const bizType = userInfo.bizType;
        // 是否为工厂（总部）
        const isFactory = bizType === 'HQ';
        if (isFactory) {
          // 如果是工厂（总部）的话，只显示售后,因为只有一个售后选项，所以就不显示pageType切换btn
          this.pageTypeData = [];
          this.selfPageType = 2;
          this.$emit('pageTypeChange', 2);
        } else {
          this.pageTypeData = [
            {
              value: 0,
              label: this.$t('Common.com_all')
            },
            {
              value: 1,
              label: this.$t('fms_pay_order_item.ying_fu_zong_bu')
            },
            {
              value: 2,
              label: this.$t('fms_pay_order_item.ying_fu_shou_hou')
            }
          ];
          // this.$emit('pageTypeChange', 1);
        }
      }
    },
    // 导出
    async exportTable() {
      const tableList = this.tableList;
      if (!tableList.length) {
        this.$message.error(
          this.$t('fms_pay_order_item.wsjkydc')
        );
        return;
      }
      const reqListData = this.getReqListData();
      const param = {};
      Object.keys(reqListData).forEach((key) => {
        const val = reqListData[key];
        if (val) {
          param[key] = val;
        }
      });

      delete param.pageSize;
      delete param.pageNum;

      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });

      let headerList = [...this.tableColumn];

      const termNumIndex = headerList.findIndex(item => item.columnCode === 'termNum');
      const termNumItem = headerList[termNumIndex];
      // 按照文档要求，修改文本
      termNumItem.columnName = this.$t('fms_pay_order_item.qi_hao');

      // 文档要求，加入总期数
      headerList.splice(termNumIndex + 1, 0, {
        columnCode: 'totalTerm',
        columnName: this.$t('fms_pay_order_item.zong_qi_shu'),
        width: 140
      });

      // 紧急程度不要
      headerList = headerList.filter(item => item.columnCode !== 'isDelay');

      const date = new Date();
      const fileName = this.$t('fms_pay_order_item.ying_fu_zhang_dan');
      const exportName = `${fileName}_${moment(date).format('YYYYMMDDHHmmss')}`;

      const reqData = {
        exportName: exportName,
        headerList: headerList,
      };

      this.$showLoading();
      try {
        await this.$exportFliePost(`${apis.billOrderTermPayableExport}?${pathParms}`, reqData);
      } catch (e) {
        this.$message.error(e.message || e.msg || this.$t('fms_pay_order_item.dao_chu_shi_bai'));
      }
      this.$closeLoading();
    },
    onTabChange(value) {
      this.$emit('tab', value);
      this.$emit('pageTypeChange', 1);
    },
    onPageTypeChange(value) {
      this.$emit('pageTypeChange', value);
    },
    // 延期付款弹窗
    onDelayDialog: function (row) {
      const rows = Array.isArray(row) ? row : [row];
      // 添加账单有用
      rows.forEach((item) => {
        item.paymentOrReceivable = true;
      });
      const item = rows[0];
      this.dialogModel.type = 'add';
      this.dialogModel.changeType = 'deferred';
      this.dialogModel.changeId = item ? item.changeId : '';
      this.dialogModel.row = rows;
      this.dialogModel.title = this.$t('fms_pay_order_item.sqyqfk');
      this.dialogVisible = true;
    },
    getReqListData() {
      const sortTypeMap = {
        1: 1,
        2: 0,
        3: 2
      };
      const billTradeStateMap = {
        1: [0, 1, 2, 6],
        2: [10, 11, 90, 100],
        3: []
      };
      const ret = {
        ...this.formSearch,
        beginTime: this.formSearch.finalTime ? this.formSearch.finalTime[0] : '',
        endTime: this.formSearch.finalTime ? this.formSearch.finalTime[1] : '',
        sortType: sortTypeMap[this.type]
      };

      if (ret.billTradeState === undefined || ret.billTradeState === '' || !ret.billTradeState.length) {
        /*
        待收款（0-未交易，1-正在交易，2-免收中， 6-待确认收款）
        已收款（10-交易完成，11-免收完成，90-交易拒绝，100-交易关闭）
        全部 （6-待确认收款，2-免收中，1-正在交易，0-未交易，10-交易完成，11-免收完成，90-交易拒绝，100-交易关闭）
        */
        ret.billTradeState = billTradeStateMap[this.type];
      }

      if (ret.termNum) {
        ret.termNum = this.formatTermNum(ret.termNum);
      }

      // if (isInit) {
      //   const initBillPaymentTime = [`${this.$moment().format('YYYY-MM-01')} 00:00:00`, `${this.$moment().format('YYYY-MM-DD')} 23:59:59`];
      //   ret.billPaymentTime = [
      //     this.$momentWorld(initBillPaymentTime[0]),
      //     this.$momentWorld(initBillPaymentTime[1])
      //   ];
      // }
      if (`${this.pageType}` === '0') {
        ret.receivableOrgType = 'HQ,SC';
      } else if (`${this.pageType}` === '1') {
        ret.receivableOrgType = 'HQ';
      } else {
        ret.receivableOrgType = 'SC';
      }
      return this.appendReqListData(ret, 'pay_order');
    },
    getPayableTotal(reqData) {
      const rData = reqData || this.getReqListData();
      this.$getJSON(apis.billOrderTermPayableTotal, rData).then((res) => {
        this.totalData = res.data || {};
      });
    },
    getTableList() {
      const deviceNo = this.formSearch.deviceNo;
      const deviceNoStr = `${deviceNo}`;
      const termNum = this.formSearch.termNum;
      // 是否为纯数字的字符串
      const testPureNum = /^\d+$/;
      // 是否为 1-3 格式的字符串
      const testRangeNum = /^\d+\-\d+$/;
      if (deviceNoStr.length > 3) {
        this.$message.error(this.$t('fms_pay_order_item.sbhcdbndy3'));
        return;
      }
      if (termNum) {

        const isPureNum = testPureNum.test(termNum);
        const isRangeNum = testRangeNum.test(termNum);
        if (!isPureNum && !isRangeNum) {
          this.$message.error(this.$t('fms_pay_order_item.qsrhfqh'));
          return;
        }
      }
      const reqData = this.getReqListData();
      this.$getJSON(apis.billOrderPayPage, reqData).then((res) => {
        this.tableList = this.formatTableList(res.data.records);
        this.totalRows = res.data.total;
      });
      this.getPayableTotal(reqData);
    },
    formatTableList(list) {
      if (isMock) {
        list.forEach((item) => {
          item.orderId = '';
          item.billId = '';
          item.paymentCode = '';
          item.billPaymentCode = '';
          item.paymentId = '';
        });
      }
      return list;
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.billPaymentTime = '';
      // 然后日期组件重新根据init-value赋值
      this.billPaymentTimeKey++;
      setTimeout(() => {
        this.onPageChange({ page: 1 });
      }, 300);
    },
  },
};
</script>

<style lang="scss">
.pay-order-item {

  // display: flex;
  // flex-direction: column;
  // height: 100%;
  .tab {
    margin-left: -16px;
    margin-right: -16px;
  }

  .half-content {
    width: 25%;
    display: inline-block;
  }

  .half-width {
    width: 50% !important;
  }

  .underline {
    color: #0d9ae0;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
